import React from 'react';
import { useParams } from 'react-router-dom';
import SpecificTradeDetails from '../components/SpecificTradeDetails';
import PageBackButton from '../components/PageBackButton';

const TradeHistoryViewerPage = () => {
  const { trade_uuid } = useParams();

  return (
    <div className="p-4 md:p-6 bg-backgroundBody text-textPrimary min-h-screen">
      <div className="flex items-center gap-4 mb-6">
        <PageBackButton label="Back to History" fallbackTo="/history" />
        <h1 className="text-2xl md:text-3xl font-bold text-primary">
          Specific Trade History
        </h1>
      </div>
      {trade_uuid ? (
        <SpecificTradeDetails tradeUuid={trade_uuid} />
      ) : (
        <p className="text-center text-red-500">No Trade ID provided.</p>
      )}
    </div>
  );
};

export default TradeHistoryViewerPage;
